import { Component, ContentChildren, Input, OnInit, QueryList } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatRadioChange } from '@angular/material/radio';
import { Orientation } from '@sb/library/base';
import { FormFieldBaseComponent } from '../form-field-base.component';
import { FormFieldRadioGroupItemComponent } from './form-field-radio-group-item.component';

@Component({
    selector: 'lib-radio-group',
    templateUrl: './form-field-radio-group.component.html',
    styleUrls: ['./form-field-radio-group.component.scss']
})
export class FormFieldRadioGroupComponent<T> extends FormFieldBaseComponent<T, FormControl<T>> implements OnInit {

    @Input() orientation: Orientation = Orientation.Vertical;
    @Input() useParentFullWidth: boolean = false;

    @ContentChildren(FormFieldRadioGroupItemComponent) itemQueryList!: QueryList<FormFieldRadioGroupItemComponent<T>>;

    constructor() {
        super();

        this.viewControl = new FormControl<T>(null as any, {nonNullable: true});
    }

    override ngOnInit() {
        super.ngOnInit();

        this.viewControl.setValue(this.formControl.value);
    }

    SetValue(value: T) {
        if (!this.formControl.disabled) {
            this.viewControl.setValue(value);
            this.SetFormControlValue(value);
            super.OnBlur();
        }
    }  

    ChangeEvent(change: MatRadioChange) {
        this.SetFormControlValue(change.value);
        super.OnBlur();
    }

    get currentItemComponent(): FormFieldRadioGroupItemComponent<T> {
        return this.itemQueryList.find(item => item.value === this.formControl.value)!;
    }
}
